<template>
    <div class="com_manager_offline">
        <div
            style="color: red; margin-bottom: 20px;font-size: 20px;text-align: center"
        >根据网关中的设备status判断是否离线</div>
        <div class="leader-tab power-tab right_container" style="width: 96%;height: 100%">
            <div class="search_cont">
                <el-form :inline="true" :model="searchForm" class="leader-style-form">
                    <el-row :gutter="24">
                        <el-col :span="6">
                            <el-form-item label="采集器标识(SN)">
                                <el-input
                                    type="text"
                                    maxlength="16"
                                    v-model="searchForm.tn_sn"
                                    :clearable="true"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="日期">
                                <el-date-picker
                                    v-model="searchForm.from_date"
                                    type="date"
                                    :picker-options="pickerOptions"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    @change="getOfflineTnList(true)"
                                ></el-date-picker>
                            </el-form-item>
                            <el-form-item label="-">
                                <el-date-picker
                                    v-model="searchForm.to_date"
                                    type="date"
                                    :picker-options="pickerOptions"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    @change="getOfflineTnList(true)"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10" style="text-align: right">
                            <el-button type="primary" size="small" @click="selectYear()">当年</el-button>
                            <el-button type="primary" size="small" @click="selectMonth()">当月</el-button>
                            <el-button type="primary" size="small" @click="selectDay()">当日</el-button>
                            <el-button type="primary" size="small" @click="getOfflineTnList()">查询</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div class="table_cont-wrap">
                <el-scrollbar style="height: 100%">
                    <el-table :data="tableData" class="leader-style-table">
                        <el-table-column width="50" align="center" label="序号">
                            <template slot-scope="scope">
                                <span>
                                    {{
                                        (paginationData.pageNum - 1) * paginationData.pageSize +
                                            scope.$index +
                                            1
                                    }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cust_name" label="公司名称" width></el-table-column>
                        <el-table-column prop="tn_sn" label="采集器标识(SN)" width></el-table-column>
                        <el-table-column prop="collector_code" label="设备号" width></el-table-column>
                        <el-table-column prop="tn_count" label="变化次数"></el-table-column>
                        <el-table-column prop="point_names" label="采集点名称"></el-table-column>
                        <el-table-column prop="is_online" label="在线状态">
                            <template slot-scope="scope">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="离线"
                                    placement="right"
                                    v-if="scope.row.is_online == 0"
                                >
                                    <div class="online_red"></div>
                                </el-tooltip>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="在线"
                                    placement="right"
                                    v-else
                                >
                                    <div class="online_green"></div>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="change_time" label="在/离线时间"></el-table-column>
                        <el-table-column label width="150">
                            <template slot-scope="scope">
                                <el-button
                                    @click="dealWarn(scope.row)"
                                    type="primary"
                                    size="small"
                                    class="leader-common-button"
                                    style="width: 100px"
                                >查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-scrollbar>
                <pagination
                    class="leader-style-pagination"
                    :paginationData="paginationData"
                    @paginationDataNew="paginationDataNew"
                ></pagination>
            </div>
        </div>

        <el-dialog
            title="查看"
            :visible.sync="dialogVisible"
            width="60%"
            class="leader-dialog"
            @close="closeDialog"
        >
            <div style="width:100%;height: 450px">
                <el-table
                    class="leader-style-table"
                    :data="tableJson"
                    style="width: 100%"
                    height="100%"
                    v-loading="loadingDtl"
                >
                    <el-table-column label="采集器标识(SN)" property="tn_sn" align="center"></el-table-column>
                    <el-table-column label="设备号" property="collector_code" align="center"></el-table-column>
                    <el-table-column label="状态" property="is_online_name" align="center"></el-table-column>
                    <el-table-column label="时间" property="change_time" align="center"></el-table-column>
                </el-table>
            </div>
            <pagination
                class="leader-style-pagination"
                :paginationData="paginationDataDtl"
                @paginationDataNew="paginationDataNewDtl"
            ></pagination>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" class="leader-common-button" @click="closeDialog">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
import pagination from "@/comon/components/pagination.vue";

export default {
    components: {
        pagination
    },
    data() {
        return {
            searchForm: {
                tn_sn: '',
                from_date: "",
                to_date: "",
            },
            dangyear: "",
            dangmonth: "",
            dangday: "",
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            data: [],
            tableData: [],
            tableLoading: false,
            systemDate: {},
            width: "calc(100% - 40px)",
            tableList: [{}, {}],
            loading: false,
            loadingDtl: false,
            dialogVisible: false,
            tableJson: [],
            currentRow: null,
            paginationData: {
                pageNum: 1,
                pageSize: 10,
                totalNum: "",
            },
            paginationDataDtl: {
                pageNum: 1,
                pageSize: 10,
                totalNum: "",
            },
        };
    },
    created() {
        this.getSysDate();
    },
    methods: {
        /**
         * 获取系统时间
         */
        getSysDate() {
            api.getSysDate1().then(res => {
                if (res) {
                    this.systemDate = res.bus_json;
                    this.dangyear = res.bus_json.sysdate4;
                    this.dangmonth = res.bus_json.sysdate3;
                    this.dangday = res.bus_json.sysdate;

                    this.searchForm.from_date = this.dangyear + "-01-01";
                    this.searchForm.to_date = this.dangday;
                    this.getOfflineTnList();
                }
            });
        },
        getOfflineTnList() {
            this.loading = true;
            api.getOfflineTnList({
                pageNum: this.paginationData.pageNum,
                pageSize: this.paginationData.pageSize,
                ...this.searchForm
            }).then(res => {
                if (res) {
                    this.loading = false;
                    this.tableData = res.bus_json.items;
                    this.paginationData.pageNum = res.bus_json.pageNum;
                    this.paginationData.pageSize = res.bus_json.pageSize;
                    this.paginationData.totalNum = res.bus_json.totalNum;
                }
            });
        },
        // 分页器公共方法
        paginationDataNew(sth) {
            this.paginationData = sth;
            this.getOfflineTnList();
        },

        selectYear() {
            this.searchForm.from_date = this.dangyear + "-01-01";
            this.searchForm.to_date = this.dangday;
            this.getOfflineTnList();
        },
        selectMonth() {
            this.searchForm.from_date = this.dangmonth + "-01";
            this.searchForm.to_date = this.dangday;
            this.getOfflineTnList();
        },
        selectDay() {
            this.searchForm.from_date = this.dangday;
            this.searchForm.to_date = this.dangday;
            this.getOfflineTnList();
        },
        /**
 * 获取系统时间
 */
        dealWarn(val) {
            this.dialogVisible = true;
            this.currentRow = val;
            this.getOfflineTnDtlList();
        },
        getOfflineTnDtlList() {
            this.loadingDtl = true;
            api.getOfflineTnDtlList({
                tn_sn: this.currentRow.tn_sn,
                collector_code: this.currentRow.collector_code,
                pageNum: this.paginationDataDtl.pageNum,
                pageSize: this.paginationDataDtl.pageSize,
            }).then(res => {
                if (res) {
                    this.tableJson = res.bus_json.items;
                    this.paginationDataDtl.pageNum = res.bus_json.pageNum;
                    this.paginationDataDtl.pageSize = res.bus_json.pageSize;
                    this.paginationDataDtl.totalNum = res.bus_json.totalNum;
                }
                this.loadingDtl = false;
            });
        },
        paginationDataNewDtl(sth) {
            this.paginationDataDtl = sth;
            this.getOfflineTnDtlList();
        },
        closeDialog() {
            this.dialogVisible = false;
        },
    }
};
</script>
<style lang="scss">
.el-tabs__item {
    color: #fff;
}

.el-tabs--card {
    margin: 0;
}

.com_manager_offline {
    //  width: 100%;
    height: 100%;
    margin: 0 40px 40px 40px;
    // display: flex;
    // flex-direction: row;
    padding-top: 5px;
    background: url("../../../assets/image/index/table-bg.png") no-repeat;
    background-size: 100% 93%;
    .right_container {
        height: calc(98% - 5px);

        .el-tabs--card {
            margin: 0;
        }
        .leader-style-form .el-input__inner {
            width: 11.5rem !important;
        }

        .online_red {
            width: 16px;
            height: 16px;
            border-radius: 8px;
            background-color: red;
            margin: auto;
        }

        .online_green {
            width: 16px;
            height: 16px;
            border-radius: 8px;
            background-color: green;
            margin: auto;
        }

        .search_cont {
            width: 100%;
            margin: 20px 0 10px 40px;

            .form {
                display: flex;
                /*justify-content: space-between;*/
                .button-group {
                    /*display: inline-block;*/
                    margin-left: 20px;
                    // button {
                    //     background: rgb(41, 184, 94);
                    //     color: white;
                    //     outline: none;
                    //     border-color: rgb(41, 184, 94);
                    // }
                    .el-button.is-disabled,
                    .el-button.is-disabled:focus,
                    .el-button.is-disabled:hover {
                        border-color: #ebeef5;
                    }
                }

                // .el-input__inner {
                //     height: 36px;
                //     line-height: 36px;
                // }
            }
        }

        .table_cont-wrap {
            width: 85%;
            height: calc(92% - 100px);
            padding: 0;
            margin-left: 40px;
            margin-right: 80px;
            margin-top: 20px;
            box-sizing: border-box;

            .green {
                height: 12px;
                width: 5px;
                background: #0089f1;
                margin: 10px;
                float: left;
            }

            width: 100%;
            font-size: 16px;
            text-align: left;
            line-height: 32px;
        }

        .table-wrap-n {
            // width: 100%;
            // overflow: auto;
            // font-size: 14px;
            font-size: 14px;
            width: 100%;
            padding: 30px 0px 0 30px;
            box-sizing: border-box;
            // height: 500px;
            height: 100%;
            margin: 0;
            position: relative;

            background-size: 100% 100%;
            overflow: auto;

            .table-header {
                width: 100%;
                display: flex;
                flex-direction: row;

                color: #fff;
                height: 50px;
                line-height: 50px;
                // border-top: 1px solid #ededed;
                // border-left: 1px solid #ededee;
            }

            .table-name {
                min-width: 200px !important;
                box-sizing: border-box;
            }

            .table-header-colum {
                flex: 1;
                // border-right: 1px solid #ededed;
                // border-bottom: 1px solid #ededed;
                // background: #f8f8f8;
                background: rgba(38, 77, 132, 0.6) !important;
                text-align: center;
                min-width: 80px;
                padding: 3px 0;
            }

            .table-row {
                display: flex;
                flex-direction: row;
                min-width: 100%;
                color: #fff;

                // border-left: 1px solid #ededee;
                .table-row-item {
                    flex: 1;
                    // border-right: 1px solid #ededed;
                    // border-bottom: 1px solid #ededed;
                    text-align: center;
                    min-width: 80px;
                    // padding: 3.5px 0;
                }
            }

            .table-row:nth-child(2n) .table-row-item {
                background: transparent !important;
                color: #ffffff;
                height: 50px;
                line-height: 50px;
            }

            .table-row:nth-child(2n + 1) .table-row-item {
                background: rgba(38, 77, 132, 0.6) !important;
                color: #ffffff;
                height: 50px;
                line-height: 50px;
            }

            .table-nodata {
                // border: 1px solid #ededed;
                text-align: center;
                // color: #999;
                color: #fff;
            }
        }
    }
}

.is-top .is-active {
    color: #56fcff !important;
}

.power-tab {
    margin: 4px 0 0 0;
}
</style>
